/**
 * @ngdoc directive
 * @name cbl.telepass.wa.directive:tlpsProposta
 * @restrict E
 * @description Componente per la visualizzazione di una pratica di telepass
 */
(function () {
  'use strict';
  var TlpsPostVenditaCtrl = function (
    $scope,
    $state,
    $stateParams,
    CONSTANTS,
    labelSrvc,
    messaggiFctr,
    postVenditaTelepassSrvc,
    $uibModal
  ) {
    this.$stateParams = $stateParams;
    this.messaggiFctr = messaggiFctr;
    this.postVenditaTelepassSrvc = postVenditaTelepassSrvc;
    this.CONSTANTS = CONSTANTS;
    this.$state = $state;
    $scope.msg = labelSrvc.getLabel;
    this.$uibModal = $uibModal;
    this.isTableReady = false;

    // Variabili della pagina
    this.ndg;

    this.templateSelezionato = false;

    var self = this;

    /*
     * -------------------------------------
     *         GESTIONE NAVIGAZIONE
     * -------------------------------------
     */

    this.risottomettiRifiutaVisibile = function () {
      return (
        self.postVenditaTelepassSrvc.datiPratica &&
        self.postVenditaTelepassSrvc.datiPratica.stato === self.CONSTANTS.STATO_PRATICA.DAREVISIONARE
      );
    };

    this.trasloco = function () {
      self.$state.go('tlps-post-vendita-trasloco', {
        ndg: self.ndg
      });
    };

    this.recuperaPratica = function () {
      self.postVenditaTelepassSrvc.spinner.callStack++;

      self.postVenditaTelepassSrvc.promiseRecuperaPratica(self.idPratica).then(function (response) {
        if (self.messaggiFctr.processaResponse(response)) {
          self.postVenditaTelepassSrvc.spinner.callStack--;
          return;
        }

        self.postVenditaTelepassSrvc.datiPratica = response.data.result;

        if (self.postVenditaTelepassSrvc.datiPratica.settore === 'TELEPASS') {
          self.postVenditaTelepassSrvc.datiPratica.class = 'PraticaTelepassDto';
        } else if (self.postVenditaTelepassSrvc.datiPratica.settore === 'VIACARD') {
          self.postVenditaTelepassSrvc.datiPratica.class = 'PraticaViacardDto';
        }

        self.selezionaSpecializzazione();
        self.isTableReady = true;
        self.postVenditaTelepassSrvc.spinner.callStack--;
      });
    };

    this.selezionaSpecializzazione = function () {
      switch (self.postVenditaTelepassSrvc.datiPratica.specializzazione) {
        case self.CONSTANTS.SPECIALIZZAZIONE_PRATICA.REVOCA_TELEPASS:
        case self.CONSTANTS.SPECIALIZZAZIONE_PRATICA.AGGIUNTA_VIACARD:
        case self.CONSTANTS.SPECIALIZZAZIONE_PRATICA.RESTITUZIONE_VIACARD:
        case self.CONSTANTS.SPECIALIZZAZIONE_PRATICA.MODIFICA_CONTO_TELEPASS:
          self.currentOperationUrl = 'postVendita.tmpl.html';
          self.templateSelezionato = true;
          // Recupero i dati dell'anagrafica per popolare l'intestazione
          self.postVenditaTelepassSrvc.promiseRecuperaAnagrafica(self.ndg).then(
            function (response) {
              if (self.messaggiFctr.processaResponse(response)) {
                self.postVenditaTelepassSrvc.spinner.callStack--;
                return;
              }
              self.postVenditaTelepassSrvc.datiCliente = response.data.result;

              self.templateSelezionato = true;
              self.postVenditaTelepassSrvc.spinner.callStack--;
            },
            function (error) {
              self.messaggiFctr.processaResponse(error);
              self.postVenditaTelepassSrvc.spinner.callStack--;
              return;
            }
          );
          return;
        case self.CONSTANTS.SPECIALIZZAZIONE_PRATICA.TRASLOCO_TELEPASS:
          $state.go('tlps-post-vendita-trasloco', {
            ndg: self.ndg,
            idPratica: self.idPratica
          });
          return;
      }
    };

    this.risottomettiPratica = function () {
      self.$uibModal
        .open({
          animation: true,
          templateUrl: CONSTANTS.BASE_ROOT + 'components/tlpsProposta/tlpsModale/tlpsRisottometti.html',
          controller: 'TlpsModalController',
          controllerAs: 'modalCtrl',
          keyboard: false,
          backdrop: 'static',
          size: 'modal-lg'
        })
        .result.then(function (res) {});
    };

    this.rifiutaPratica = function () {
      self.$uibModal
        .open({
          animation: true,
          templateUrl: CONSTANTS.BASE_ROOT + 'components/tlpsProposta/tlpsModale/tlpsRifiuta.html',
          controller: 'TlpsModalController',
          controllerAs: 'modalCtrl',
          keyboard: false,
          backdrop: 'static',
          size: 'modal-lg'
        })
        .result.then(function (res) {});
    };

    /*:

     * -------------------------------------
     *         METODI INIZIALIZZAZIONE
     * -------------------------------------
     */

    this.init = function () {
      self.postVenditaTelepassSrvc.datiPratica = null;
      self.postVenditaTelepassSrvc.datiCliente = null;
      self.postVenditaTelepassSrvc.contrattoDaRevocare = null;
      self.postVenditaTelepassSrvc.ndgContrattoDaRevocare = null;
      self.postVenditaTelepassSrvc.contrattiCliente = null;

      self.templateSelezionato = false;

      // Forzatura per lo spegnimento dello spinner generale dell'applicazione per poter gestire
      // correttamente quello locale.
      var overlay = document.getElementById('overlay');
      if (!!overlay) {
        overlay.setAttribute('style', 'display:none;');
      }

      labelSrvc.labelsPronte.then(function () {
        self.ndg = self.$stateParams.ndg;
        self.idPratica = self.$stateParams.idPratica;

        self.postVenditaTelepassSrvc.spinner.callStack++;

        if (self.idPratica) {
          self.recuperaPratica();
        } else {
          self.currentOperationUrl = 'postVendita.tmpl.html';
          self.templateSelezionato = true;

          // Recupero i dati dell'anagrafica per popolare l'intestazione
          self.postVenditaTelepassSrvc.promiseRecuperaAnagrafica(self.ndg).then(
            function (response) {
              if (self.messaggiFctr.processaResponse(response)) {
                self.postVenditaTelepassSrvc.spinner.callStack--;
                return;
              }
              self.postVenditaTelepassSrvc.datiCliente = response.data.result;
              self.isTableReady = true;
              self.postVenditaTelepassSrvc.spinner.callStack--;
            },
            function (error) {
              self.messaggiFctr.processaResponse(error);
              self.postVenditaTelepassSrvc.spinner.callStack--;
              return;
            }
          );
        }
      });
    };

    // INIZIALIZZAZIONE

    self.init();
  };

  TlpsPostVenditaCtrl.$inject = [
    '$scope',
    '$state',
    '$stateParams',
    'TLPS_CONSTANTS',
    'TlpsLabelSrvc',
    'TlpsMessaggiFctr',
    'TlpsPostVenditaSrvc',
    '$uibModal'
  ];

  var TemplateUrl = function (CONSTANTS) {
    return CONSTANTS.BASE_ROOT + CONSTANTS.COMPONENTS_PATH + 'tlpsPostVendita/tlpsPostVendita.html';
  };

  TemplateUrl.$inject = ['TLPS_CONSTANTS'];

  var TlpsPostVenditaComponent = {
    controller: TlpsPostVenditaCtrl,
    controllerAs: 'tlpsPostVenditaCtrl',
    templateUrl: TemplateUrl
  };

  angular.module('cbl.telepass.wa').component('tlpsPostVendita', TlpsPostVenditaComponent);
})();



//////////////////
// WEBPACK FOOTER
// ./app/components/tlpsPostVendita/tlpsPostVendita.cmpt.js
// module id = 19
// module chunks = 0